// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js","682":"component---src-pages-about-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"aab2a460f1a74f920bd5","678":"434a65b3ef8433acd8a7","682":"f73bc97c335077096615","883":"963f9a3173333e119a67"}[chunkId] + ".js";
};